var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('Header'),_c('v-layout',{staticClass:"flex-shrink-0"},[_c('side-menu',{attrs:{"display-menu":_vm.isLoggedIn,"is-admin":_vm.isAdmin}}),_c('v-main',{staticClass:"ma-0 pa-3",attrs:{"id":"main"}},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }